import angular from 'angular';
import parentListItem from './parent-list-item.directive';
import ParentListItemController from './parent-list-item.controller';
import listItem from './list-item.directive';


export default angular.module('app.components.advisory.global.ssListItem', [])
  .controller('ParentListItemController', ParentListItemController)
  .directive('parentListItem', parentListItem)
  .directive('listItem', listItem)
  .name;

console.log('app.components.advisory.global.ssListItem created');
